export default function RiskThreatAssessmentDirective() {
  return {
    template: require('./risk-threat-assessment.html'),
    scope: {
      assessmentId: '=',
      assessmentPermissions: '<',
      status: '=',
    },
    controller: 'RiskThreatAssessmentController',
    controllerAs: 'riskThreatAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
